import axios from "axios";
import { BACKEND_URL } from "../utils/constant";

const getAllBankInfos = async (token) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.get(`${BACKEND_URL}api/bank-infos`, config);
    return response;
};

const getOneBankInfo = async (token, id) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.get(`${BACKEND_URL}api/bank-infos/${id}`, config);
    return response;
};

const postBankInfo = async (token, data) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.post(`${BACKEND_URL}api/bank-infos`, data, config);
    return response;
};

const updateBankInfo = async (token, id, data) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.put(`${BACKEND_URL}api/bank-infos/${id}`, data, config);
    return response;
};

const deleteBankInfo = async (token, id) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.delete(`${BACKEND_URL}api/bank-infos/${id}`, config);
    return response;
};

const reorderBankInfos = async (token, ids) => {
    const config = { headers: { authorization: `Bearer ${token}` } };
    const response = await axios.put(
        `${BACKEND_URL}api/bank-infos/reorder`,
        { ids },
        config
    );
    return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    getAllBankInfos,
    getOneBankInfo,
    postBankInfo,
    updateBankInfo,
    deleteBankInfo,
    reorderBankInfos,
};
